import { Link } from "react-router-dom";
import { Ban } from "lucide-react";
import { PaymentShell, BRAND_GRADIENT } from "@/components/payment/PaymentShell";

const PaymentCancelled = () => {
  return (
    <PaymentShell
      eyebrow="Payment"
      title="Checkout cancelled"
      icon={<Ban className="h-6 w-6 text-og01-text-muted" />}
      footer={
        <div className="flex items-center justify-center gap-4 text-[13px]">
          <a
            href="https://og01.ai/remediation-pricing"
            className="font-semibold underline-offset-2 hover:underline"
            style={{
              background: BRAND_GRADIENT,
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Return to plans
          </a>
          <span className="text-og01-text-muted">·</span>
          <Link to="/auth/login" className="text-og01-text-secondary underline-offset-2 hover:underline">
            Sign in
          </Link>
        </div>
      }
    >
      <p className="text-[15px] text-og01-text-secondary">
        You left Stripe before payment finished. Nothing was charged, and no OG01 account was created.
      </p>
      <p className="mt-3 text-[13px] text-og01-text-muted">
        If this was a mistake, go back to plans and complete checkout. You’ll return here only after a successful payment.
      </p>
    </PaymentShell>
  );
};

export default PaymentCancelled;
